import { render } from "./Promotions.vue?vue&type=template&id=4b7f61fd&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"

import "./Promotions.vue?vue&type=style&index=0&id=4b7f61fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7f61fd"]])

export default __exports__